import "shared/globals"
import Vue from 'vue'
import router from './router'
import OrgAccess from '../organization-access.vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import TurbolinksAdapter from 'vue-turbolinks'
import _ from 'lodash'
import vuetify from '../plugins/vuetify.js'

Vue.use(Vuex)
Vue.use(TurbolinksAdapter)
try { Vue.use(VueAxios, axios) } catch(e) {}

export const state = {
  currentUser: '',
  authorization:'',
  institutionName: '',
  organization: ''
}


export const getters = {
  currentUser(state){
    return state.currentUser
  },
  institutionName(state){
    return state.institutionName
  },
  organization(state){
    return state.organization
  }
} 

export const mutations = {
  
};

export const actions = {
  updateUserOrganization({state},data){
    return axios.patch(`/api/v1/users/${state.currentUser.id}`, data,{headers: {"Authorization": state.authorization.token}})
    .then(response=>{
      console.log(response.data)
      //commit('showSnackbar', {text: 'Admin has been updated.'}, { root: true })
    }).catch(error=>{
      //commit('showSnackbar', {text: 'Creating item failed.'}, { root: true })
    })
  }
}

export const store = new Vuex.Store({
  getters,
  mutations,
  actions,
  state
})

document.addEventListener('turbolinks:load', function() {
  Vue.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  Vue.axios.defaults.headers.common['Accept'] = 'application/json'
  var element = document.querySelector('#organization_access')
  if(element){
    store.state.authorization = JSON.parse(element.dataset.authorization)
    store.state.currentUser = JSON.parse(element.dataset.currentUser)
    store.state.institutionName = element.dataset.institutionName
    store.state.organization = JSON.parse(element.dataset.organization)
    const app = new Vue({
      el: element,
      store,
      template: '<OrgAccess />',
      components: { OrgAccess },
      router,
      vuetify
    })
  }
})